import { Col, DatePicker, Radio, Row, Select, Spin, Tag, message } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { http } from "../../helpers/http";
import { AxiosError, AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";
import { BonusAdjustForm } from "../Payment/BonusAdjustForm";

type PmpFormProps = {
    service: any;
    setDisabled: (state: boolean) => void;
    submit: boolean;
    destroyModal: () => void;
    refresh: () => void;
    refreshBalance: () => void;
    student: any;
    groupID: number;
    finalPrice: number;
    setBonus: (state: string) => void;
}

export const PmpForm = ({ service, setDisabled, submit, destroyModal, refresh, refreshBalance, student, groupID, finalPrice, setBonus }: PmpFormProps) => {
    const { t } = useTranslation();
    const [cities, setCities] = useState([] as any);
    const [languages, setLanguages] = useState([] as any);
    const [filters, setFilters] = useState({
        city: null as string | null,
        language: null as string | null,
    });
    const [groups, setGroups] = useState([] as any);
    const [group, setGroup] = useState(null as any);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [bonusAmount, setBonusAmount] = useState("0");
    const [selectedService, setSelectedService] = useState<any>(null);
    const [studentBalance, setStudentBalance] = useState<{
        current_credit: number;
        bonus_balance: number;
    } | null>(null);

    const getCities = () => {
        http.get(`cities`).then((res: AxiosResponse) => {
            setCities(res.data.data)
        })
    };

    const getLanguages = () => {
        http.get(`languages`).then((res: AxiosResponse) => {
            setLanguages(res.data.data)
        })
    };

    // const fetchGroups = () => {
    //     setGroup(null);
    //     setLoading(true);
    //     http.get(`get-student-medical-groups`, {
    //         params: {
    //             no_paginate: 1,
    //             availableOnly: 1,
    //             fe: 1
    //         }
    //     }).then((res: AxiosResponse) => {
    //         console.log(res)
    //         setLoading(false);
    //         setGroups(res.data.data)
    //     }).catch((err: AxiosError) => {
    //         setLoading(false);
    //     })
    // };

    // const fetchGroups = async () => { before test version
    //     setGroup(null);
    //     setLoading(true);
    
    //     try {
    //         const [medicalRes, pmpOnlineRes] = await Promise.all([
    //             http.get(`get-student-medical-groups`, {
    //                 params: {
    //                     no_paginate: 1,
    //                     availableOnly: 1,
    //                     fe: 1,
    //                 },
    //             }),
    //             http.get(`pmp-online-study-groups`),
    //         ]);
    
    //         const medicalGroups = medicalRes?.data?.data || [];
    //         const pmpOnlineGroupsRaw = pmpOnlineRes?.data?.data || [];
    
    //         const isPmpOnlineEnrolled = student?.studygroups?.some(
    //             (g: any) =>
    //                 g?.active === 1 &&
    //                 g?.study_group?.category_id === 23 
    //         );
    
    //         console.log("Medical groups:", medicalGroups);
    //         console.log("Raw PMP Online groups:", pmpOnlineGroupsRaw);
    //         console.log("Student is PMP Online enrolled:", isPmpOnlineEnrolled);
    
    //         let finalGroups = medicalGroups;
    
    //         if (isPmpOnlineEnrolled && Array.isArray(pmpOnlineGroupsRaw)) {
    //             const uniquePmpOnlineGroups = pmpOnlineGroupsRaw
    //                 .filter((pg: any) => !medicalGroups.some((mg: any) => mg.id === pg.id))
    //                 .map((pg: any) => ({ ...pg, isPmpOnline: true }));
    
    //             finalGroups = [...medicalGroups, ...uniquePmpOnlineGroups];
    
    //             console.log("Unique PMP Online groups after deduplication:", uniquePmpOnlineGroups);
    //         }
    
    //         setGroups(finalGroups);
    //         console.log("Final merged group list set to state:", finalGroups);
    
    //     } catch (err) {
    //         console.error("Failed to fetch groups:", err);
    //         setGroups([]);
    //     } finally {
    //         setLoading(false);
    //         console.log("Finished fetchGroups.");
    //     }
    // };
    const fetchBalance = async () => {
        try {
            const res: AxiosResponse = await http.get(`balance`);
            setStudentBalance(res.data.data);
        } catch (error) {
            console.error("Failed to fetch balance", error);
            setStudentBalance({ current_credit: 0, bonus_balance: 0 }); 
        }
    };
    const fetchGroups = async () => {
        setGroup(null);
        setLoading(true);
    
        try {
            const [medicalRes, pmpOnlineRes] = await Promise.all([
                http.get(`get-student-medical-groups`, {
                    params: {
                        no_paginate: 1,
                        availableOnly: 1,
                        fe: 1,
                    },
                }),
                http.get(`pmp-online-study-groups`),
            ]);
    
            const medicalGroups = medicalRes?.data?.data || [];
            const pmpOnlineGroupsRaw = pmpOnlineRes?.data?.data || [];
    
            // console.log("Medical groups:", medicalGroups);
            // console.log("Raw PMP Online groups:", pmpOnlineGroupsRaw);
            // console.log("Student object:", student);
    
            const isLatvian = student?.language?.iso === "lv";
           // console.log("Is student Latvian:", isLatvian);
    
            let finalGroups = [];
    
            if (isLatvian) {
                finalGroups = pmpOnlineGroupsRaw.map((pg: any) => ({ ...pg, isPmpOnline: true }));
               // console.log("Latvian student: showing only PMP Online groups");
            } else {
                finalGroups = medicalGroups;
                //console.log("Non-Latvian student: showing only medical groups");
            }
    
            setGroups(finalGroups);
           // console.log("Final group list:", finalGroups);
        } catch (err) {
            console.error("Failed to fetch groups:", err);
            setGroups([]);
        } finally {
            setLoading(false);
           // console.log("Finished fetchGroups.");
        }
    };

    // const submitPmp = async (): Promise<boolean> => {
    //     const isExtra = service.hasOwnProperty("pivot")
    //         ? !!service.pivot.paid
    //             ? 1
    //             : 0
    //         : 0
    //     http.post(`add-service-for-self`, {
    //         services: [
    //             {
    //                 service_id: service.id,
    //                 group: group,
    //                 extra: isExtra,
    //                 bonus_amount: bonusAmount
    //             }
    //         ]
    //     }).then(async (res: AxiosResponse) => {
    //         if (!!!isExtra) {
    //             await http.post(`medical-groups-attach/${student.id}/${groupID}`, {
    //                 medical_group: group,
    //                 main: 1,
    //                 extra_pmp: 0
    //             }).catch((err: AxiosError) => {
    //                 console.log(err.response?.data?.msg)
    //                 const { msg } = err.response?.data;
    //                 message.error("Kļūda! " + msg)
    //             })
    //         }
    //         refresh();
    //         refreshBalance();
    //         message.success(t('notification.service_bought_sucessfully'))
    //         return true
    //     }).catch((err: AxiosError) => {
    //         errorMessageResolver(err);
    //         const msg = err.response?.data?.msg
    //         message.error(typeof msg === "string" ? msg : "Kļūda!");
    //         return false
    //     })
    //     return false;
    // }
    const submitPmp = async (): Promise<boolean> => {
        const isExtra = service?.pivot?.paid ? 1 : 0;
        const isLatvian = student?.language?.iso === "lv";
        const credit = studentBalance?.current_credit ?? 0;
        const bonusVal = parseFloat(bonusAmount) || 0;
        const payableAmount = Math.max(finalPrice - bonusVal, 0);
    
        // console.log("SUBMIT PMP START");
        // console.log("Student ID:", student?.id);
        // console.log("Selected group ID:", group?.id);
        // console.log("Is Latvian:", isLatvian);
        // console.log("Is Extra:", isExtra);
        // console.log("Credit:", credit);
        // console.log("Bonus value:", bonusVal);
        // console.log("Final price:", finalPrice);
        // console.log("Payable amount (after bonus):", payableAmount);
    
        if (!isExtra && credit < payableAmount) {
            message.error("Nepietiek līdzekļu kontā.");
            return false;
        }
    
        try {
            if (isLatvian) {
                // const payload: any = {
                //     payment_type: "is_paying",
                //     app: 0,
                //     bonus_sum: bonusVal,
                //     bonuses: {
                //         bonus_pmp: {
                //             bonus_amount: bonusVal
                //         }
                //     }
                // };
                const payload: any = {
                    payment_type: "is_paying",
                    app: 0
                  };
                  
                  if (bonusVal > 0 && selectedService?.id) {
                    payload.bonus_sum = bonusVal;
                    payload.bonuses = {
                      [selectedService.id]: {
                        bonus_amount: bonusVal
                      }
                    };
                  }
    
                //console.log("PMP Online payload:", payload);
                await http.post(`pmp-online-add-group/${group.id}`, payload);
    
            } else {
                await http.post(`add-service-for-self`, {
                    services: [
                        {
                            service_id: service.id,
                            group: group,
                            extra: isExtra,
                            bonus_amount: bonusAmount
                        }
                    ]
                });
    
                if (!isExtra) {
                    await http.post(`medical-groups-attach/${student.id}/${groupID}`, {
                        medical_group: group,
                        main: 1,
                        extra_pmp: 0
                    }).catch((err: AxiosError) => {
                        const { msg } = err.response?.data;
                        message.error("Kļūda! " + msg);
                    });
                }
            }
    
            refresh();
            refreshBalance();
            message.success(t('notification.service_bought_sucessfully'));
            return true;
    
        } catch (err: AxiosError | any) {
            const msg = err.response?.data?.msg;
            message.error(typeof msg === "string" ? msg : "Kļūda!");
            return false;
        }
    };

    useEffect(() => {
        getCities();
        getLanguages();
        fetchGroups();
        fetchBalance();
    }, []);

    useEffect(() => {
        if (submit) {
            submitPmp().then((result: boolean) => {
                if (result) {
                    destroyModal();
                }
            });
        }
    }, [submit]);

    useEffect(() => {
        if (
            group === null || group === undefined
        ) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [group])

    useEffect(() => {
        if (group?.services?.length && !selectedService) {
            setSelectedService(group.services[0]);
        }
    }, [group, selectedService]);

    // useEffect(() => {
    //     console.log(filters)
    //     if (filters.city && filters.language) {
    //         fetchGroups();
    //     }
    // }, [filters])

    useEffect(() => {
        setBonus(bonusAmount)
    }, [bonusAmount])

    return <Row gutter={[20, 30]}>
        {/* <Col span={12}>
            <p style={{ marginBottom: 10 }}>{t('common.city')}</p>
            <Select
                style={{ width: 200, marginTop: 5 }}
                onChange={(value: any) => {
                    setFilters((prev: any) => {
                        return {
                            ...prev,
                            city: value
                        }
                    })
                }}
                onClick={e => e.stopPropagation()}
            >
                {
                    cities.map((city: any) => {
                        return <Select.Option key={city.id} value={city.id}>{city.value}</Select.Option>
                    })
                }
            </Select>
        </Col>
        <Col span={12}>
            <p style={{ marginBottom: 10 }}>{t('common.language')}</p>
            <Select
                style={{ width: 200, marginTop: 5 }}
                onChange={(value: any) => {
                    setFilters((prev: any) => {
                        return {
                            ...prev,
                            language: value
                        }
                    })
                }}
                onClick={e => e.stopPropagation()}
            >
                {
                    languages.map((language: any) => {
                        return <Select.Option key={language.id} value={language.id}>{language.value}</Select.Option>
                    })
                }
            </Select>
        </Col> */}
        <Col span={24}>
            <p style={{ marginBottom: 10 }}>{t('navigation.study_groups')}</p>
            {
                loading
                    ? <Row justify="center"><Spin /></Row>
                    : <Select
                       // value={group ? group : undefined} this stuff before pmponline
                       value={group?.id}
                        style={{ width: "100%", marginTop: 5 }}
                        // onChange={(value: any) => {  this stuff before pmponline
                        //     setGroup(value)
                        // }}
                        onChange={(id: any) => {
                            const selected = groups.find((g: any) => g.id === id);
                            setGroup(selected);
                        
                            if (selected?.services?.length) {
                                setSelectedService(selected.services[0]); 
                            } else {
                                setSelectedService(null); 
                            }
                        }}
                        onClick={e => e.stopPropagation()}
                        loading={loading}
                        optionLabelProp="label"
                    >
                        {/* {
                            groups.map((group: any) => {
                                return <Select.Option key={group.id} value={group.id} label={<b>{group.name} {group.online_date}, {group.medical_date}</b>}>
                                    <div style={{ fontStyle: "bold", padding: 4, border: "1px solid #f0f0f0" }}>
                                        <p style={{ marginBottom: 2 }}>{group.name}</p>
                                        <p style={{ marginBottom: 2 }}>1. nod. Tiešsaistē: {group.online_date} {moment(group.online_from, "HH:mm:ss").format("HH:mm")} {moment(group.online_to, "HH:mm:ss").format("HH:mm")}</p>
                                        <p style={{ marginBottom: 2 }}>2. nod. Klātienē: {group.medical_date} {moment(group.medical_from, "HH:mm:ss").format("HH:mm")} {moment(group.medical_to, "HH:mm:ss").format("HH:mm")}</p>
                                    </div>
                                </Select.Option>
                            })
                        } */}
                           {
                            groups.map((group: any) => {
                                return <Select.Option key={group.id} value={group.id} label={group.name}>
                                <div style={{ padding: 4, border: "1px solid #f0f0f0" }}>
                                  <p style={{ marginBottom: 2 }}>{group.name}</p>
                                  <p style={{ marginBottom: 2 }}>
                                    1. nod. Tiešsaistē: {group.start_date} {group.start_time} - {group.end_time}
                                  </p>
                                  <p style={{ marginBottom: 2 }}>
                                    2. nod. Klātienē: {group.theory_lessons?.[0]?.lesson_date ?? "Nav datuma"} {group.theory_lessons?.[0]?.time_from ?? ""} - {group.theory_lessons?.[0]?.time_to ?? ""}
                                  </p>
                                </div>
                              </Select.Option>
                            })
                        }

                    </Select>
            }
            <BonusAdjustForm
                amount={finalPrice}
                type="bonus_pmp"
                student={student}
                setBonusAmount={setBonusAmount}
                bonusAmount={bonusAmount}
            />
        </Col>
        {
            error.length > 0
            && <Tag color="red" style={{ marginBottom: 10, marginTop: 10, whiteSpace: "normal", width: "100%", textAlign: "center" }}>
                {error}
            </Tag>
        }
    </Row>
}